import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Navigation from './navigation';
import Footer from '../footer';

import Popup from '../popup';

function Navbar(props) {
    const [contactOpen, setContactOpen] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);

    const isStaff = props.isAdminAccountManager || props.isInternalReadOnly;

    return (
        <div className={props.bread_crumbs ? '' : 'no-breadcrumb'}>
            <div className={isStaff ? 'site-wrapper admin' : 'site-wrapper'}>
                <div className="header level-3">
                    <div className="navigation">
                        <div className="container">
                            <Navigation
                                nav={props.nav}
                                hidePartnerSelection={
                                    props.hidePartnerSelection
                                }
                                onOpenContact={() => setContactOpen(true)}
                                onOpenHelp={() => setHelpOpen(true)}
                            />
                        </div>
                    </div>
                    {props.bread_crumbs ? props.bread_crumbs : null}
                </div>
                <div className="container content">
                    <div className="content-inner">{props.children}</div>
                </div>
                <Footer />
            </div>
            <Popup
                contactOpen={contactOpen}
                helpOpen={helpOpen}
                onCloseContact={() => setContactOpen(false)}
                onCloseHelp={() => setHelpOpen(false)}
            />
        </div>
    );
}

Navbar.propTypes = {
    bread_crumbs: PropTypes.element,
    nav: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    hidePartnerSelection: PropTypes.bool,
    isAdminAccountManager: PropTypes.bool.isRequired,
    isInternalReadOnly: PropTypes.bool.isRequired,
};

export default connect((store) => ({
    isAdminAccountManager: store.partnerManager.isAdminAccountManager,
    isInternalReadOnly: store.partnerManager.isInternalReadOnly,
}))(Navbar);
